const deviceTypes = {
  POND_GUARD: {
    name: "PondGuard",
    lang_key: "Comn_pond_guard",
    key: "POND_GUARD"
  },
  POND_MOTHER: {
    name: "PondMother",
    lang_key: "Comn_pond_mother",
    key: "POND_MOTHER"
  },
  SHRIMP_TALK: {
    name: "ShrimpTalk",
    lang_key: "Comn_shrimptalk",
    key: "SHRIMP_TALK"
  },
  GATEWAY: {
    name: "Gateway",
    lang_key: "Comn_gateway",
    key: "GATEWAY"
  }
};

export default deviceTypes;
